import headerMainTpl from './main';
import headerTpl from './base';

export {
    headerMainTpl,
    headerTpl
}